// extracted by mini-css-extract-plugin
export default {"root":"ActionTooltip_root__0Ih6I","trigger":"ActionTooltip_trigger__6OOV6","tooltip":"ActionTooltip_tooltip__kHpNB","arrow":"ActionTooltip_arrow__1C9rr"};